export const selectBadge = state => state.badge;
